/**
 * des：租户管理--租户模块管理
 * date：2019-7-15
 * author：zhaoqing
 */
'use strict';
angular.module('moduleManageModule', [])
    .controller('moduleManageCtrl', ['$scope', 'trsspliceString', '$q', '$filter', 'tManageMentService', 'modalDialog', 'trsHttpService',
        function($scope, trsspliceString, $q, $filter, tManageMentService, modalDialog, trsHttpService) {

            // token 租户id
            var token = '', tenantId = '';

            // tree 组件配置
            $scope.expanded = [];
            $scope.selectedNode = {
                // moduleName: '',
                // moduleDesc: '',
                // moduleId: ''
            };
            $scope.dataForTheTree = [];
            $scope.treeOptions = {
                nodeChildren: 'childList',
                dirSelectable: true,
                allowDeselect: false,
                injectClasses: {
                    ul: 'a1 manage-tree',
                    li: 'a2',
                    liSelected: 'a7',
                    iExpanded: 'icon-previewright a3',
                    iCollapsed: 'icon-previewright a4',
                    iLeaf: 'a5',
                    label: 'a6',
                    labelSelected: 'rolegrouplabselected',
                },
                isLeaf: function(node) {
                    return !node.childList || !node.childList.length;
                },
            };

            // 表单
            $scope.editNode = {};
            // 是否是新建节点状态
            $scope.isAddNode = false;
            // 表单验证
            // $scope.validate = true;

            // 清空表单数据
            // function resetForm(obj) {
            //     for(var key in obj) {
            //         if(obj.hasOwnProperty(key)) obj[key] = '';
            //     }
            // }

            // 获取树节点
            function getTreeData() {
                $scope.loadingPromise = trsHttpService.httpServer('/api/tenantcenter/moduleConfig/getModuleList', {}, 'get', '', { token: token }).then(function(data) {
                    $scope.dataForTheTree = data.datas;
                });
            }

            // 获取当前登录人的信息 获取token
            function getCurrentInfo() {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_extuser',
                    methodname: 'getCurrUserInfo',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', '', { token: token }).then(function(data) {
                    if (data.TENANTID) {
                        tenantId = data.TENANTID;
                        getToken(deffer.resolve);
                    }
                });
                return deffer.promise;
            }

            // 获取登录token
            function getToken(resolve) {
                var params = {
                    serviceid: 'getToken',
                    tenantId: tenantId,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', '', { token: token }).then(function(data) {
                    if (data.token) {
                        token = data.token;
                        resolve();
                    }
                });
            }

            // 获取 token 后 ，请求树节点
            getCurrentInfo().then(function() {
                getTreeData();
            });

            $scope.showToggle = function() {
                // console.log('toggle')
                // console.log(arguments)
            };

            $scope.showSelected = function(node) {
                // console.log('show');
                // console.log(arguments);
                $scope.isAddNode = false;
                $scope.selectedNode = node;
                $scope.editNode = {
                    canRelatedRegion: node.canRelatedRegion,
                    isHide: node.isHide,
                    isSysBorad: node.isSysBorad,
                    moduleName: node.moduleName,
                    moduleCode: node.moduleCode,
                    moduleDesc: node.moduleDesc,
                    moduleId: node.moduleId,
                    parentId: node.parentId,
                };
            };

            // 保存
            $scope.saveNode = function() {
                if (isEmpty($scope.editNode.moduleName) || isEmpty($scope.editNode.moduleDesc) || isEmpty($scope.editNode.moduleCode)) {
                    modalDialog.alertType('提示', '名称和详情都是必填', 'error', 'confirm', function() {
                    });
                    return;
                }
                if ($scope.isAddNode) {
                    $scope.editNode.parentId = $scope.editNode.root ? '' : $scope.editNode.moduleId;
                    delete $scope.editNode.moduleId;
                }
                $scope.editNode.isHide = $scope.editNode.isHide ? 1 : 0;
                $scope.editNode.isSysBorad = $scope.editNode.isSysBorad ? 1 : 0;
                $scope.loadingPromise = trsHttpService.httpServer('/api/tenantcenter/moduleConfig/saveOrUpdateModule', $scope.editNode, 'get', '', { token: token }).then(function(data) {
                    if (data.code === '200') {
                        modalDialog.saveModel('提示', '保存成功', 'success', false);
                        getTreeData();
                        if ($scope.isAddNode) {
                            $scope.addNode('isRoot');
                        }
                    } else {
                        modalDialog.alertType('提示', data.msg || '保存失败', 'error', 'confirm', function() {
                        });
                    }
                });
            };

            // 新建节点
            $scope.addNode = function(isRoot) {
                $scope.isAddNode = true;
                $scope.editNode.moduleName = '';
                $scope.editNode.moduleCode = '';
                $scope.editNode.moduleDesc = '';
                $scope.editNode.canRelatedRegion = false;
                $scope.editNode.isHide = false;
                $scope.editNode.isSysBorad = false;
                $scope.editNode.root = !!isRoot;
            };

            // 删除节点
            $scope.deleteNode = function() {
                modalDialog.alertType('确定删除？', '', 'info', true, function() {
                    deleteNodeFn();
                }, function() {

                });
            };

            // 删除操作
            function deleteNodeFn() {
                var params = {
                    moduleId: $scope.editNode.moduleId,
                };
                $scope.loadingPromise = trsHttpService.httpServer('/api/tenantcenter/moduleConfig/delModule', params, 'post', '', { token: token }).then(function(data) {
                    console.log(data);
                    if (data.code === '200') {
                        modalDialog.saveModel('提示', '删除成功', 'success', false);
                        getTreeData();
                        $scope.selectedNode = {};
                        $scope.editNode = {};
                    } else {
                        modalDialog.alertType('提示', data.msg || '删除失败', 'error', 'confirm', function() {
                        });
                    }
                });
            }

            // 表单验证
            function isEmpty(fileds) {
                return fileds === undefined || fileds.replace(/(^\s*)|(\s*$)/g, '') === '';
            }

            $scope.judgeStatus = function(status) {
                if (status == -1) {
                    return false;
                } else {
                    return !!status;
                }
            };
            return false;
        },
    ]);